module.exports = __webpack_public_path__ + "assets/img/album.2e599f11.svg";